var map = {
	"./Kfc-logo.png": "0186",
	"./amex.png": "6e80",
	"./chip.png": "8e19",
	"./delivery_call.png": "ec53",
	"./delivery_gosend.png": "76f0",
	"./delivery_grab.png": "fcc8",
	"./delivery_whatsapp.png": "5e64",
	"./discover.png": "e8d1",
	"./gosend_icon.png": "bcc5",
	"./grab_express_icon.png": "c563",
	"./mastercard.png": "3c3e",
	"./no_data.png": "9684",
	"./no_driver.png": "7c41",
	"./olsera_logo.png": "149c",
	"./order_cashier.png": "eb62",
	"./pay_at_cashier.png": "8372",
	"./phone.png": "1e37",
	"./product_not_available.png": "2d58",
	"./scanqr.png": "2620",
	"./troy.png": "ceb6",
	"./visa.png": "a2368",
	"./warning_icon.png": "af77",
	"./whatsapp.png": "d253"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "64a2";